/**
 * Locale-aware name normalization used by the name lane (I.E.2 / #39).
 *
 * The pipeline:
 *   1. Trim leading/trailing whitespace.
 *   2. Collapse internal whitespace runs to single space.
 *   3. NFD-decompose and strip combining marks (so `café` → `cafe`).
 *   4. Lowercase via `String.prototype.toLocaleLowerCase` so non-Latin
 *      scripts (Turkish `İ`, German `ß`) get a defensible default. We
 *      pass no locale list — the Workspace's locale will be threaded
 *      through in Phase 2 when locale-aware ordering matters.
 *
 * The result is a "lookup key" used both at write time (index
 * population on entity-name facts) and at query time (matcher). Storing
 * the normalised form on disk keeps the SQL index a plain `TEXT` column
 * with a `LIKE`-prefix and equality query — no need for SQLite ICU.
 */
export function normalizeName(raw: string): string {
  const trimmed = raw.replace(/\s+/g, ' ').trim();
  if (trimmed.length === 0) return '';
  // NFD + strip combining marks (Unicode general category Mn).
  const stripped = trimmed.normalize('NFD').replace(/\p{M}/gu, '');
  return stripped.toLocaleLowerCase();
}
